module.exports = __webpack_public_path__ + "static/istock-970899460-compressor-07af85baeb72849468e0823fa9729ae4.jpg";